import {useShoppingCartStore} from "./store";

export const useCartGoodsQuantity = (id: number) => {
    const {cartItems, updateQuantity} = useShoppingCartStore();

    const cartItem = cartItems.find((item) => item.id === id);
    const targetQuantity = cartItem?.quantity ?? 0;
    const onIncriment = () => {
        updateQuantity(id, targetQuantity + 1);
    }

    const onDecrement = () => {
        const quantity = Math.max((targetQuantity - 1), 1);
        updateQuantity(id, quantity);
    }
    return {
        onIncriment,
        onDecrement,
        targetQuantity

    }


}